import $ from 'jquery'

/* global filterOptgroupOptions, refreshTomSelect -- exposed by tom-select.js */

// Set dropdowns and weight input for new Notice view
// ---------------------------------------------------------------------

$(document).on('turbo:load turbo:render', () => {
  const selectEstate = $('#notice_estate')
  if (!selectEstate.length) return // Not on the notices page

  const selectBuilding = $('#notice_building')
  const selectFloor = $('#notice_floor_id')
  const selectContactPerson = $('#notice_contact_person_id')
  const selectNoticeKind = $('#notice_notice_kind_id')
  const managedByCascade = selectEstate.closest('[data-cascade]').length > 0

  let buildings
  let floors
  if (managedByCascade) {
    if (selectContactPerson[0]?.tomselect) selectContactPerson[0].tomselect.destroy()
  } else {
    // Destroy Tom Select on cascading selects so we can capture the raw server-rendered
    // <option>/<optgroup> HTML. refreshTomSelect() will re-init them after each cascade.
    for (const el of [selectBuilding, selectFloor, selectContactPerson]) {
      if (el[0]?.tomselect) el[0].tomselect.destroy()
    }
    buildings = selectBuilding.data('source-options-html')
    if (buildings == null) {
      buildings = selectBuilding.html()
      selectBuilding.data('source-options-html', buildings)
    }
    floors = selectFloor.data('source-options-html')
    if (floors == null) {
      floors = selectFloor.html()
      selectFloor.data('source-options-html', floors)
    }
  }
  let contactPersons = selectContactPerson.data('source-options-html')
  if (contactPersons == null) {
    contactPersons = selectContactPerson.html()
    selectContactPerson.data('source-options-html', contactPersons)
  }

  const costCenterNames = $('#notice_notice_kind_cost_center').data('idcostcenters')

  const emptyOption = "<option selected='selected'></option>"

  // Disable secondary/tertiary selects of cascades
  if (!managedByCascade) {
    if (selectBuilding.val() === '') selectBuilding.prop('disabled', true)
    if (selectBuilding.val() === '') selectFloor.prop('disabled', true)
  }
  if (selectContactPerson.val() === '') selectContactPerson.prop('disabled', true)

  if (!managedByCascade) {
    // Populate buildings
    const selectedBuilding = selectBuilding.find('option:selected').val()
    selectEstate.off('change.noticeCascade').on('change.noticeCascade', () => {
      const selectedEstate = selectEstate.val()
      const selectedEstateLabel = selectEstate.find('option:selected').text()
      const options = filterOptgroupOptions(buildings, selectedEstate, selectedEstateLabel, selectEstate[0]?.selectedIndex)
      const numberOfBuildings = options ? (options.match(/value/g) || []).length : 0
      if (options) {
        selectBuilding.prop('disabled', false)
        selectBuilding.html(options)
        // If nothing is selected yet, add empty option, so User has to select right value first, but only when more than one Building is selectable
        if (!(selectedBuilding > 0 || numberOfBuildings === 1)) {
          selectBuilding.prepend(emptyOption)
        }
        if (selectBuilding.val() === '') selectFloor.prop('disabled', true)
        if (selectFloor.val() !== null && selectFloor.val() !== '') {
          selectContactPerson.prop('disabled', true)
          selectContactPerson.prepend(emptyOption)
        }
      } else {
        selectBuilding.empty()
      }
      refreshTomSelect(selectBuilding)
      populateSelectFloors()
    })

    // Populate floors
    selectBuilding.off('change.noticeCascade').on('change.noticeCascade', () => {
      if (selectBuilding.val() !== '') selectFloor.prop('disabled', false)
      populateSelectFloors()
    })

    const selectedFloor = selectFloor.find('option:selected').val()
    const populateSelectFloors = () => {
      const building = selectBuilding.val()
      const buildingLabel = selectBuilding.find('option:selected').text()
      const options = filterOptgroupOptions(floors, building, buildingLabel, selectBuilding[0]?.selectedIndex)
      const numberOfFloors = options ? (options.match(/value/g) || []).length : 0
      if (options) {
        selectFloor.prop('disabled', false)
        selectFloor.html(options)
        // If nothing is selected yet, add empty option, so User has to select right value first, but only when more than one Floor is selectable
        if (!(selectedFloor > 0 || numberOfFloors === 1)) {
          selectFloor.prepend(emptyOption)
        }
      } else {
        selectFloor.empty()
      }
      refreshTomSelect(selectFloor)
      if (selectFloor.val() !== null && selectFloor.val() !== '') {
        selectFloor.trigger('change')
      }
    }
  }

  selectFloor.off('change.noticeCascade').on('change.noticeCascade', () => {
    if (selectEstate.val() !== '') selectContactPerson.prop('disabled', false)
    populateSelectContactPersons()
  })

  if (managedByCascade) {
    selectEstate.off('change.noticeCascadeManaged').on('change.noticeCascadeManaged', () => {
      if (selectEstate.val() !== '') selectContactPerson.prop('disabled', false)
      populateSelectContactPersons()
    })
  }

  const selectedContactPerson = selectContactPerson.find('option:selected').val() // only works here, don't know why
  // Populate contact_persons
  const populateSelectContactPersons = () => {
    const estate = selectEstate.val()
    const estateLabel = selectEstate.find('option:selected').text()
    const options = filterOptgroupOptions(contactPersons, estate, estateLabel, selectEstate[0]?.selectedIndex)
    const numberOfContactPersons = options ? (options.match(/value/g) || []).length : 0
    if (options) {
      selectContactPerson.html(options)
      // If nothing is selected yet, add empty option, so User has to select right value first, but only when more than one ContactPerson is selectable
      if (!(selectedContactPerson > 0 || numberOfContactPersons === 1)) {
        selectContactPerson.prepend(emptyOption)
      }
    } else {
      selectContactPerson.empty()
    }
    refreshTomSelect(selectContactPerson)
  }

  // Change value of disabled cost_center_showonly text input or enable cost_center input field, if selected Notice::Kind has no cost_center set
  const setNoticeKindCostCenter = () => {
    const noticeKindId = selectNoticeKind.find(':selected').val()
    const costCenterName = costCenterNames?.[noticeKindId]
    if (costCenterName) {
      $('#cost_center_showonly').show()
      $('#notice_cost_center').hide()
      // Set disabled text field
      $('#cost_center_showonly').val(costCenterName)
      // Set hidden field
      $('#notice_cost_center').val(costCenterName)
    } else {
      if (selectNoticeKind.val() === '') { // Nothing selected yet
        $('#cost_center_showonly').show()
        $('#notice_cost_center').hide()
      } else {
        $('#cost_center_showonly').hide()
        $('#notice_cost_center').show()
      }
      // Clear that stuff
      $('#cost_center_showonly').val('')
      const formResubmitValue = $('#notice_cost_center').data('form-resubmit-cost-center') // Get user selected value after form validation has failed
      $('#notice_cost_center').val(formResubmitValue)
    }
  }

  // Populate cost_center
  selectNoticeKind.off('change.noticeKindCostCenter').on('change.noticeKindCostCenter', setNoticeKindCostCenter)

  // Also trigger everything after page (re)load, e.g. validation fail
  setNoticeKindCostCenter()
  selectEstate.trigger('change')
})

// Disable save button on Notice rating form until all ratings are selected
// ---------------------------------------------------------------------

$(document).on('turbo:load turbo:render', () => {
  $('form.rate_notice button[type="submit"]').prop('disabled', true)
  $('form.rate_notice input[type="radio"]').off('change.noticeRating').on('change.noticeRating', () => {
    if ($('form.rate_notice input[type="radio"]:checked').length === $('form.rate_notice .rating.form').length) {
      $('form.rate_notice button[type="submit"]').prop('disabled', false)
    } else {
      $('form.rate_notice button[type="submit"]').prop('disabled', true)
    }
  })
})

// Show rating when state_change accept is selected
// ------------------------------------------------

$(document).on('turbo:load turbo:render', () => {
  $('#notice_message_state_change').off('change.noticeMessageState').on('change.noticeMessageState', function() {
    if ($(this).val() === 'accept') {
      $('.rate_notice_fields').show()
    } else {
      $('.rate_notice_fields').hide()
    }
  })
})
